export {
  useContentInteraction,
  ContentInteraction,
  shouldTrackInteraction,
  HOVER_THRESHOLD_MS,
} from './useContentInteraction'

export type {
  ContentInteractionEvent,
  ContentBlockType,
  InteractionAction,
  PresentationSurface,
  PlacementContainer,
  PlacementLayout,
  ArtworkMediaFormat,
  DeepMaybe,
} from './types'

export { validateContentInteractionEvent } from './validation'

export { SuggestedRailItemInteraction } from './InteractionBuilders/suggestedRailItemInteraction'
